import { Component, Prop } from 'vue-property-decorator'
import { KhAnimationProps, KhText } from '@internal-libraries/kheops-ui-lib'
import { DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT } from '../../const'
import ResourceType from '../../../../../../dPbloc/vue/Classes/ClvrResourceType'
import ClvrScreenControlDataCell from '../ClvrScreenControlDataCell'
import { ClvrScreenControlHeadersLabelsEnum } from '../../enum'
import { DEFAULT_HEIGHT_CONTAINER } from '../../../../const'
import ScreenResolutionHelper from '../../../../../../system/vue/Classes/ScreenResolutionHelper'

@Component({
    components: {
        KhText,
    },
})
export default class ClvrScreenControlMaterialAndRemarkNoteCell extends ClvrScreenControlDataCell {
    @Prop({ type: String, default: '' })
    public materials!: string

    @Prop({ type: String, default: '' })
    public remarks!: string

    @Prop({ type: Array, default: () => [] })
    public additionalMaterials!: ResourceType[]

    public get materialAndRemark() {
        return [
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.MATERIAL_TO_PROVIDE) ? this.materials : '',
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.REMARKS) ? this.remarks : '',
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.MATERIAL_LIST)
                ? this.additionalMaterials?.map(material => material.label ?? '').join(', ')
                : '',
        ]
            .filter(item => !!item)
            .join(', ')
    }

    public get directiveAnimationRightToLeft(): KhAnimationProps {
        return {
            ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
            text: this.materialAndRemark,
            containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER),
        }
    }
}
